import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginPopupService {
  private readonly dialog = inject(MatDialog);

  /** @deprecated Prefer triggerLogin(), which opens the dialog directly. */
  public subject = new BehaviorSubject<string>('');

  triggerLogin(): void {
    this.openSignIn();
  }

  openSignIn(): void {
    void import('@app/auth/login/login.component').then(({ LoginComponent }) => {
      const dialogRef = this.dialog.open(LoginComponent, {
        maxWidth: '100vw',
        maxHeight: '-webkit-fill-available',
        panelClass: 'auth-dialog',
      });

      dialogRef.componentInstance.switchModalSignUp.subscribe(() => {
        this.dialog.closeAll();
        this.openSignUp();
      });
      dialogRef.componentInstance.loginCloseModal.subscribe(() => {
        this.dialog.closeAll();
      });
    });
  }

  openSignUp(): void {
    void import('@app/auth/signup/signup.component').then(({ SignupComponent }) => {
      const dialogRef = this.dialog.open(SignupComponent, {
        maxWidth: '100vw',
        maxHeight: '-webkit-fill-available',
        panelClass: 'auth-dialog',
      });

      dialogRef.componentInstance.switchModalSignIn.subscribe(() => {
        this.dialog.closeAll();
        this.openSignIn();
      });
      dialogRef.componentInstance.signupCloseModal.subscribe(() => {
        this.dialog.closeAll();
      });
    });
  }
}
